<ion-row class="ion-center ion-margin-top">
  <ion-col class="ion-text-center">
    <div class="circle-loader" [ngClass]="{'load-complete': completed}">
      <div class="checkmark draw" [style.display]="completed ? 'inline' : 'none'"></div>
    </div>
  </ion-col>
</ion-row>